// Staff marker for testing while logged out. Opening any page with
// ?fluent_staff=1 remembers it in this browser (localStorage); from then on
// every PostHog event carries is_staff: true, so dashboards can filter Fluent's
// own test visits out. ?fluent_staff=0 clears it. Events still send (no
// opt-out), and nothing shows on screen.
//
// Applied in PostHog's before_send (entrypoints/inertia.tsx), so it is read at
// the moment each event is sent: the first events of a page, and pageviews,
// carry it too (a React effect would run after the page's own first events).
import type { BeforeSendFn } from "posthog-js";

const KEY = "fluent_staff";

/** Whether this browser is marked as staff; applies ?fluent_staff=1 / =0 first. */
export function isStaff(): boolean {
  try {
    const flag = new URLSearchParams(window.location.search).get(KEY);
    if (flag === "1") window.localStorage.setItem(KEY, "1");
    if (flag === "0") window.localStorage.removeItem(KEY);
    return window.localStorage.getItem(KEY) === "1";
  } catch {
    // Storage blocked (private mode, settings): no marker.
    return false;
  }
}

/** PostHog before_send: is_staff on every event from a marked browser, never on others. */
export const markStaff: BeforeSendFn = (event) => {
  if (!event) return event;
  const properties = { ...event.properties };
  if (isStaff()) properties.is_staff = true;
  else delete properties.is_staff;
  return { ...event, properties };
};
